import { TMoneySourcesState } from '../../../../reducers/v2';
import { EMoneySource } from '../../../../types/reducers/user';

import { IMoneySourceProps, EMoneySourceWidgetType, TMoneySourceHandleChange } from '../../types';
import { MONEY_SOURCE_OPTION_LABELS_BY_TYPE } from '../../constants';

interface IParams {
  sources: TMoneySourcesState;
  activeSource: EMoneySource | null;
  widgetType: EMoneySourceWidgetType;
  handleClick: TMoneySourceHandleChange;
}

export const getOptions = ({ sources, activeSource, widgetType, handleClick }: IParams): Array<IMoneySourceProps> => {
  const sourceTypes = sources.map(({ type }) => type);
  const isOnlyOneSourceAvailable = sourceTypes.length === 1;

  return [
    {
      disabled: isOnlyOneSourceAvailable && sourceTypes.includes(EMoneySource.Self),
      label: MONEY_SOURCE_OPTION_LABELS_BY_TYPE[widgetType].agent,
      active: activeSource === EMoneySource.Master,
      value: EMoneySource.Master,
      handleClick: () => handleClick(EMoneySource.Master),
    },
    {
      disabled: isOnlyOneSourceAvailable && sourceTypes.includes(EMoneySource.Master),
      label: MONEY_SOURCE_OPTION_LABELS_BY_TYPE[widgetType].personal,
      active: activeSource === EMoneySource.Self,
      value: EMoneySource.Self,
      handleClick: () => handleClick(EMoneySource.Self),
    },
  ];
};
